import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'

import ThemeInterface from '@/theme-interface'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  mark: {
    color: theme.palette.primary.main,
    marginLeft: 4,
  },
}))

interface RequiredMarkProps {
  className?: string
}

/** The asterisk behind the label of a required field. Hidden from screen readers - mark the field itself as required. */
const RequiredMark = ({ className }: RequiredMarkProps) => {
  const classes = useStyles()

  return <span className={clsx(classes.mark, className)} aria-hidden='true'>*</span>
}

export default RequiredMark
